export const setLocalAndSessionOnLogin = () => {
  let tabs = { matchedKey: getRandomValues() + new Date().getTime(), time: new Date().getTime() };
  localStorage.setItem("sessionToMatch", JSON.stringify(tabs));
  sessionStorage.setItem("sessionChecked", JSON.stringify(tabs));
  localStorage.setItem("shouldReload", JSON.stringify(true));
};

export const getRandomValues = () => {
  var bufferValues = new Uint8Array(2048 / 8);
  crypto.getRandomValues(bufferValues);
  return bufferValues[0]
}

const alertTheUser = () => {
  alert(
    "You've been logged out of your previous session. Please refresh the page"
  );
  window.location.reload();
};

const doLocalAndSessionMatch = () => {
  let local = JSON.parse(localStorage.getItem("sessionToMatch"));
  let sessionChecked = sessionStorage.getItem("sessionChecked")
    ? JSON.parse(sessionStorage.getItem("sessionChecked"))
    : null;
  if (
    !sessionChecked ||
    sessionChecked.matchedKey !== local.matchedKey ||
    sessionChecked.time !== local.time
  ) {
    sessionStorage.setItem("sessionChecked", JSON.stringify(local));
    alertTheUser();
  }
};

export const handleSessionOnLoan = () => {
  let local = localStorage.getItem("sessionToMatch")
    ? JSON.parse(localStorage.getItem("sessionToMatch"))
    : null;
  !local || Object.entries(local).length === 0
    ? createNewSession()
    : handleInconsistentSession(local);
};

const createNewSession = () => {
  let local = { matchedKey: getRandomValues() + new Date().getTime(), time: new Date().getTime() };
  localStorage.setItem("sessionToMatch", JSON.stringify(local));
  sessionStorage.setItem("sessionChecked", JSON.stringify(local));
};

const handleInconsistentSession = (local) => {
  let shouldReload = localStorage.getItem("shouldReload")
    ? JSON.parse(localStorage.getItem("shouldReload"))
    : false;
  let sess = sessionStorage.getItem("sessionChecked")
    ? JSON.parse(sessionStorage.getItem("sessionChecked"))
    : null;
  !sess || sess.matchedKey !== local.matchedKey || sess.time !== local.time
    ? sessionStorage.setItem("sessionChecked", JSON.stringify(local))
    : null;

  if (
    shouldReload &&
    (!sess || sess.matchedKey !== local.matchedKey || sess.time !== local.time)
  ) {
    localStorage.setItem("shouldReload", JSON.stringify(false));
    alertTheUser();
  } else {
    localStorage.setItem("shouldReload", JSON.stringify(false));
  }
};

export const handleVisibilityChange = () =>
  document.visibilityState === "visible"
    ? localStorage.getItem("sessionToMatch")
      ? doLocalAndSessionMatch()
      : alertTheUser()
    : null;

export const setSessionEvents = () => {
  document.addEventListener("visibilitychange", handleVisibilityChange, false);
  window.addEventListener("load", handleSessionOnLoan);
};
